// Module
var code = `<div class="form-group {{form.htmlClass}}"
     ng-class="{
        'has-error': form.disableErrorState !== true && hasError(),
        'has-success': form.disableSuccessState !== true && hasSuccess(),
        'has-feedback': form.feedback !== false
        }"
>
    <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">
        {{form.title}}
    </label>
    <div class="{{form.fieldHtmlClass}}">
        <div ng-controller="SelectMultyAsyncByGroupCtrl" class="row">
            <div class="col-md-3">
                <ui-select sf-field-model="replaceAll"
                           ng-model="\$\$value\$\$.group"
                           class="{{form.fieldHtmlClass}}"
                           theme="bootstrap"
                           reset-search-input="true"
                           title="{{form.title}}"
                           on-select="on_change_group(\$item, form.service, form.method, \$\$value\$\$)"
                >
                    <ui-select-match placeholder="{{form.placeholder}}">{{\$select.selected.name}}</ui-select-match>
                    <ui-select-choices repeat="item.value as item in form.titleMap | filter: \$select.search">
                        <div ng-bind-html="item.name | highlight: \$select.search"></div>
                    </ui-select-choices>
                    <ui-select-no-choice>
                        We couldn't find any choices...
                    </ui-select-no-choice>
                </ui-select>
            </div>
            <div class="col-md-9">
                <ui-select multiple
                           sf-field-model="replaceAll"
                           ng-model="\$\$value\$\$.items"
                           spinner-enabled="true"
                           remove-selected="false"
                           limit="{{form.maxItems}}"
                           class="form-control"
                           on-select="on_change_items(\$\$value\$\$, model)"
                >
                    <ui-select-match placeholder="{{form.placeholder}}">
                        {{\$item.name}}
                    </ui-select-match>

                    <ui-select-choices
                            refresh="updateTitleMap(\$select.search, form.service, form.method, \$select.ngModel.\$\$rawModelValue)"
                            refresh-delay="0"
                            repeat="item.value as item in title_map"
                    >
                        <div ng-bind-html="item.name"></div>
                    </ui-select-choices>

                    <ui-select-no-choice>
                        Not found...
                    </ui-select-no-choice>

                </ui-select>

            </div>

        </div>

    </div>
    <div class="help-block" sf-message="form.description"></div>
</div>
`;
// Exports
module.exports = code;